import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";
import { useDeviceStore } from "../../../stores/Assets/device";
import { t } from "i18next";

const EditDevice = ({
  toggleEditDeviceModal,
  showEditDeviceModal,
  rowData,
  spaceList,
}) => {
  const { updateDevice } = useDeviceStore((state) => state);
  const [formData, setFormData] = useState({
    device_id: "",
    space_id: "",
    is_active: true,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (rowData) {
      setFormData({
        device_id: rowData.device_id || "",
        space_id: rowData.space_id || "",
        is_active: rowData.is_active !== undefined ? rowData.is_active : true,
      });
    }
  }, [rowData]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await updateDevice(rowData.device_id, formData);
      toggleEditDeviceModal();
    } catch (error) {
      console.error("Error updating device:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={showEditDeviceModal}
      toggle={toggleEditDeviceModal}
      size="lg"
      centered
    >
      <ModalHeader toggle={toggleEditDeviceModal}>
        {t("Edit Device")} - {rowData?.device_id}
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="device_id">{t("Device ID")}</Label>
                <Input
                  id="device_id"
                  name="device_id"
                  type="text"
                  value={formData.device_id}
                  disabled
                  className="bg-light"
                />
                <small className="text-muted">
                  Device ID cannot be changed
                </small>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="space_id">{t("Space")} *</Label>
                <Input
                  id="space_id"
                  name="space_id"
                  type="select"
                  value={formData.space_id}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">{t("Select a space")}</option>
                  {spaceList.map((space) => (
                    <option key={space.space_id} value={space.space_id}>
                      {space.space_id} - {space.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="is_active"
                    checked={formData.is_active}
                    onChange={handleInputChange}
                  />
                  {t("Active")}
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={toggleEditDeviceModal}
            disabled={isSubmitting}
          >
            {t("Cancel")}
          </Button>
          <Button
            color="primary"
            type="submit"
            disabled={isSubmitting || !formData.space_id}
          >
            {isSubmitting ? t("Updating...") : t("Update Device")}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default EditDevice;
